module.exports = __webpack_public_path__ + "img/fig01.f85f31a3.jpg";